import {
  RoutineActivity,
  SchedulerPreferenceV3,
  ScheduledAction,
  TaskItemForSchedule,
} from '@demind-inc/core';
import { atom } from 'recoil';
import { AISchedulerLogicElement, AssistantChatMessage } from '../types';

interface AiSchedulerFeedbackApiInfoType {
  appApiRes: string;
  scienceApiReq: string;
  scienceApiRes: string;
  currentTime: string;
  preference: string;
}

interface AISchedulerInput {
  preferences: SchedulerPreferenceV3;
  date: string;
  todos?: TaskItemForSchedule[];
  routine?: RoutineActivity[];
  userMessage?: string;
}

export const isAISchedulerSetupOverlayVisibleAtom = atom<boolean>({
  key: 'aiScheduler.isAISchedulerSetupOverlayVisible',
  default: false,
});

export const isRunningAISchedulerAtom = atom<boolean>({
  key: 'aiScheduler.isRunningAIScheduler',
  default: false,
});

export const aiScheduledActionsAtom = atom<ScheduledAction[]>({
  key: 'aiScheduler.aiScheduledActions',
  default: [],
});

export const aiSchedulerErrorAtom = atom<string | null>({
  key: 'aiScheduler.aiSchedulerError',
  default: null,
});

export const aiFeedbackModalVisibleAtom = atom<boolean>({
  key: 'aiScheduler.aiFeedbackModalVisible',
  default: false,
});

export const aiSchedulerFeedbackApiInfoAtom = atom<AiSchedulerFeedbackApiInfoType | null>({
  key: 'aiScheduler.aiSchedulerFeedbackApiInfo',
  default: null,
});

export const aiSchedulerLogicElementsAtom = atom<AISchedulerLogicElement[]>({
  key: 'aiScheduler.aiSchedulerLogicElements',
  default: ['timebox', 'routine', 'task'],
});

export const acceptedEventScheduleIdsAtom = atom<string[] | null>({
  key: 'aiScheduler.acceptedEventScheduleIds',
  default: null,
});

export const aiSchedulerInputAtom = atom<AISchedulerInput | null>({
  key: 'aiScheduler.aiSchedulerInput',
  default: null,
});

export const aiSchedulerChatSessionIdAtom = atom<string | null>({
  key: 'aiScheduler.aiSchedulerChatSessionId',
  default: null,
});

export const aiSchedulerChatMessagesAtom = atom<AssistantChatMessage[]>({
  key: 'aiScheduler.aiSchedulerChatMessages',
  default: [],
});

export const aiSchedulerSummaryAtom = atom<string | null>({
  key: 'aiScheduler.aiSchedulerSummary',
  default: null,
});

export const aiSchedulerStatusTextAtom = atom<string[]>({
  key: 'aiScheduler.aiSchedulerStatusText',
  default: [],
});

export const aiSchedulerProcessingDateAtom = atom<string[]>({
  key: 'aiScheduler.aiSchedulerProcessingDate',
  default: [],
});

export const aiSchedulerWeekCompleteAtom = atom<boolean>({
  key: 'aiScheduler.aiSchedulerWeekComplete',
  default: true,
});

export const aiSchedulerV5StreamAbortControllerAtom = atom<AbortController | null>({
  key: 'aiScheduler.aiSchedulerV5StreamAbortController',
  default: null,
});
